import {$authHost} from "./index";
import {API_ENDPOINTS} from "../utils/urls";


// Товарно-транспортні накладні (ТТН, форма N 1-ТН). Кожна ТТН прив'язана до
// підприємства (companyId). Клієнт формує .xlsx з шаблону (див. utils/ttnXlsx.ts)
// і надсилає його разом із JSON полів; бекенд зберігає обидва та вміє
// конвертувати збережений .xlsx у .pdf (ttnCreatePdfAPI) — аналогічно pdfPutAPI.
//
// Очікувана форма сутності з бекенду:
// {
//   id, companyId, company: { id, name },
//   number, date,                         // № та дата накладної (для списку)
//   fields: { ...TtnFields },             // повний знімок полів форми
//   xlsxFile: string | null,              // шлях у media/
//   pdfFile:  string | null,              // шлях у media/
//   payee: { id, name, hasStamp, hasSign } | null,  // отримувач платежу ТТН
//   createdBy: { id, username },
//   createdAt, updatedAt
// }

// Всі файли віддаються з `${REACT_APP_API_URL}media/<path>` (як pdf розрахунків).

// payeeId: id получателя платежа для фильтра, 'none' — без получателя,
// undefined / 'all' — без фильтра.
export async function ttnGetAPI(companyId: string | number, payeeId?: string | number){
    try {
        const payeeQ = payeeId != null && payeeId !== 'all' ? '&payee=' + payeeId : '';
        return await $authHost.get(API_ENDPOINTS.TTN + '?company=' + companyId + payeeQ);

    } catch (error: any) {
        return error;
    }
}

export async function ttnGetByIdAPI(id: string | number){
    try {
        return await $authHost.get(API_ENDPOINTS.TTN + '/' + id);

    } catch (error: any) {
        return error;
    }
}

const asFormData = (fields: any, xlsx: Blob): FormData => {
    const fd = new FormData();
    fd.append('data', JSON.stringify(fields));
    fd.append('xlsx', xlsx, 'ttn.xlsx');
    return fd;
};

export async function ttnPostAPI(
    companyId: string | number,
    userId: string | number,
    fields: any,
    xlsx: Blob,
){
    try {
        return await $authHost.post(
            API_ENDPOINTS.TTN + '/' + companyId + '?userId=' + userId,
            asFormData(fields, xlsx),
        );

    } catch (error: any) {
        return error;
    }
}

export async function ttnUpdateAPI(id: string | number, fields: any, xlsx: Blob){
    try {
        return await $authHost.put(API_ENDPOINTS.TTN + '/' + id, asFormData(fields, xlsx));

    } catch (error: any) {
        return error;
    }
}

export async function ttnDeleteAPI(id: string | number){
    try {
        return await $authHost.delete(API_ENDPOINTS.TTN + '/' + id);

    } catch (error: any) {
        return error;
    }
}

// Бекенд конвертує збережений .xlsx цієї ТТН у .pdf, зберігає pdfFile і
// повертає оновлену сутність (аналог pdfPutAPI для розрахунків).
export async function ttnCreatePdfAPI(id: string | number){
    try {
        return await $authHost.put(API_ENDPOINTS.TTN + '/' + id + '/pdf');

    } catch (error: any) {
        return error;
    }
}

// Бэкенд берёт текущий PDF накладной, накладывает печать и подпись
// привязанного получателя платежа и отдаёт готовый файл (blob). На сервере
// не сохраняется. Координаты — центр картинки в долях страницы (cy от низа);
// чего не передали — берётся из сохранённого Ttn.stampPos, иначе из дефолта.
// save=1 — запомнить переданное положение на самой ТТН.
export type TtnStampParams = {
    stampCxFrac?: number; stampCyFrac?: number; stampWidthPt?: number;
    signCxFrac?: number;  signCyFrac?: number;  signWidthPt?: number;
    save?: 0 | 1;
};

export async function ttnStampedPdfAPI(id: string | number, params?: TtnStampParams){
    try {
        const qs = params
            ? '?' + Object.entries(params)
                .filter(([, v]) => v !== undefined && v !== null)
                .map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`)
                .join('&')
            : '';
        return await $authHost.get(API_ENDPOINTS.TTN + '/' + id + '/stamped-pdf' + qs, {
            responseType: 'blob',
        });

    } catch (error: any) {
        return error;
    }
}
